import {
  IoPencil,
  IoBackspaceSharp,
  IoCheckmarkCircleSharp,
} from "react-icons/io5";
import classes from "./StaffEntry.module.css";
import { useState } from "react";
export default function StaffEntry({
  data,
  index,
  deleteHandler,
  saveEditHandler,
}) {
  // console.log("re rendering staff entry");
  // console.log(data.name);
  const [isEdit, setIsEdit] = useState(false);
  const [newName, setNewName] = useState(data?.name);
  function editHandler1(e) {
    setIsEdit(true);
    let id = e.target.parentNode.childNodes[1].value;
    let nameElement = e.target.parentNode.childNodes[2];
    nameElement.style.display = "block";
    nameElement.focus();
  }
  function saveTheEditHandler1(e) {
    let id = e.target.parentNode.childNodes[1].value;
    let name = e.target.parentNode.childNodes[2].value;

    console.log(id);
    console.log(name);
    // console.log(data.name);
    if (name != data.name) saveEditHandler(id, name);
    setIsEdit(false);
  }

  function nameChangeHandler(e) {
    console.log(e.target.value);
    setNewName(e.target.value);
  }
  function deleteHandler1(e) {
    setIsEdit(false);
    console.log(data.name);

    let p = window.confirm("Are You Sure, You want to Delete the Entry?");

    let id = e.target.parentNode.childNodes[1].value;
    console.log(id);
    if (p == true) deleteHandler(id);
  }

  return (
    <>
      <div className={classes.container}>
        <div className={classes.staffEntry}>
          <span>{index + 1}.</span>

          <input type="text" id="staffId" readOnly value={data?.id} hidden />
          {isEdit ? (
            <>
              <input
                type="text"
                defaultValue={data.name}
                id={"editName"}
                onChange={nameChangeHandler}
                autoFocus
              />
              <div
                className={classes.iconBox}
                onClick={(e) => {
                  saveTheEditHandler1(e);
                }}
              >
                <div className={classes.saveIcon}>
                  <IoCheckmarkCircleSharp />
                </div>
              </div>
            </>
          ) : (
            <>
              <p>{data?.name}</p>
              <div
                className={`${classes.iconBox} ${classes.tooltip}`}
                onClick={editHandler1}
              >
                <div className={`${classes.iconEdit} ${classes.tooltip}`}>
                  <IoPencil />
                  <span className={classes.tooltiptext}>Edit</span>
                </div>
              </div>
            </>
          )}

          <div
            className={`${classes.iconBox} ${classes.tooltip}`}
            onClick={deleteHandler1}
          >
            <div className={`${classes.iconDelete} `}>
              <IoBackspaceSharp />
              <span className={classes.tooltiptext}>Delete</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
